import React from 'react'
import PropTypes from 'prop-types'
import Instance from 'highcharts'
import VariablePieAddOn from 'highcharts/modules/variable-pie'
import HighCharts from 'highcharts-react-official'
import { GlobalStyle, Root } from './PieChart.styles'

VariablePieAddOn(Instance)

/**
 * The PieChart's component.
 */
const PieChart = props => {
  const { data, hoverColor, id, tooltipFormatter } = props
  const options = {
    accessibility: { enabled: false },
    chart: { type: 'variablepie' },
    series: [{ data, innerSize: '20%', minPointSize: 10, zMin: 0 }],
    plotOptions: {
      variablepie: {
        point: {
          events: {
            mouseOver() {
              this.originalColor = this.color
              this.update({ color: hoverColor })
            },
            mouseOut() {
              this.update({ color: this.originalColor })
            }
          }
        }
      }
    },
    title: { text: '' },
    tooltip: { formatter: tooltipFormatter }
  }

  return (
    <>
      <GlobalStyle />
      <Root id={id}>
        <HighCharts highcharts={Instance} options={options} />
      </Root>
    </>
  )
}

PieChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      y: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      z: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    })
  ).isRequired,
  hoverColor: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  tooltipFormatter: PropTypes.func.isRequired
}

export default PieChart
